import {
	GET_API_MAIN_STATUS, GET_API_SYNC_STOCK_STATUS, GET_API_SYNC_GENERAL_STATUS,
	GET_API_STADISTICS_STATUS, GET_JOB_LOGS, GET_ERRORS
} from "../actions/types";

const initialState = {
	actionType: '',
	dataApiMain: null,
	dataApiStadistics: null,
	dataApiSyncGeneral: null,
	dataApiSyncStock: null,
	jobLogs: [],
	error: null,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_API_MAIN_STATUS:
			return {
				...state,
				actionType: action.type,
				dataApiMain: action.payload
			};
		case GET_API_STADISTICS_STATUS:
			return {
				...state,
				actionType: action.type,
				dataApiStadistics: action.payload
			};
		case GET_API_SYNC_STOCK_STATUS:
			return {
				...state,
				actionType: action.type,
				dataApiSyncStock: action.payload
			};
		case GET_API_SYNC_GENERAL_STATUS:
			return {
				...state,
				actionType: action.type,
				dataApiSyncGeneral: action.payload
			};
		case GET_JOB_LOGS:
			return {
				...state,
				actionType: action.type,
				jobLogs: action.payload
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload
			};
		default:
			return state;
	}
}